<template>
  <div class="xingxiang-actions">
    <div class="page-heading">
      <div>
        <el-button type="text" icon="el-icon-arrow-left" @click="$router.push({ name: 'Xingxiang' })">返回智体列表</el-button>
        <h2>{{ shapeName ? shapeName + '的动作' : '智体动作' }}</h2>
        <p>为当前智体添加动作，填写名称和资源链接即可。</p>
      </div>
      <el-button type="primary" icon="el-icon-plus" :disabled="!ready || loading" @click="openAdd">添加动作</el-button>
    </div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon></el-alert>
    <div class="list-panel">
      <div class="list-heading"><strong>动作列表（{{ actions.length }}）</strong><el-button size="small" icon="el-icon-refresh" :loading="loading" @click="loadList">刷新</el-button></div>
      <el-table v-loading="loading" :data="actions" border empty-text="暂无动作，点击右上角添加动作">
        <el-table-column prop="name" label="动作名称" min-width="180"></el-table-column>
        <el-table-column label="动作链接" min-width="320">
          <template slot-scope="scope"><a v-if="isHttpUrl(scope.row.action_url)" :href="scope.row.action_url" target="_blank" rel="noopener noreferrer">{{ scope.row.action_url }}</a><span v-else>{{ scope.row.action_url }}</span></template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加动作" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false" :before-close="closeDialog">
      <el-form label-width="90px" @submit.native.prevent="save">
        <el-form-item label="动作名称" required><el-input v-model="form.name" maxlength="255" placeholder="例如：招手" :disabled="saving"></el-input></el-form-item>
        <el-form-item label="动作链接" required><el-input v-model="form.action_url" type="textarea" :rows="4" maxlength="2048" placeholder="请输入完整的 http:// 或 https:// 资源链接" :disabled="saving"></el-input></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { createXingxiangActionApi, isHttpUrl, normalizeXingxiangId } from '@/api/xingxiangAction'

const api = createXingxiangActionApi(axios)
export default {
  data () {
    return { shapeName: '', actions: [], loading: false, saving: false, ready: false, error: '', dialogVisible: false, requestSerial: 0, form: { name: '', action_url: '' } }
  },
  created () { this.loadList() },
  watch: {
    '$route.query.xingxiang_id' () { this.dialogVisible = false; this.loadList() }
  },
  methods: {
    isHttpUrl,
    async loadList () {
      const serial = ++this.requestSerial
      this.error = ''
      this.ready = false
      this.actions = []
      this.shapeName = ''
      this.loading = true
      try {
        const id = normalizeXingxiangId(this.$route.query.xingxiang_id)
        const data = await api.list(id)
        if (serial !== this.requestSerial) return
        this.shapeName = data.xingxiang.name || ('智体 ' + id)
        this.actions = data.list
        this.ready = true
      } catch (e) {
        if (serial === this.requestSerial) this.error = e.message || '动作列表加载失败，请重试'
      } finally {
        if (serial === this.requestSerial) this.loading = false
      }
    },
    openAdd () {
      this.form = { name: '', action_url: '' }
      this.dialogVisible = true
    },
    closeDialog (done) { if (!this.saving) done() },
    async save () {
      if (this.saving || !this.ready) return
      const currentId = this.$route.query.xingxiang_id
      this.saving = true
      try {
        await api.create(currentId, this.form)
        this.$message.success('添加成功')
        if (currentId === this.$route.query.xingxiang_id) {
          this.dialogVisible = false
          await this.loadList()
        }
      } catch (e) { this.$message.error(e.message || '保存失败，请重试') }
      finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.xingxiang-actions { padding: 24px; background: #f5f7fa; min-height: 100vh; box-sizing: border-box; }
.page-heading, .list-heading { display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.page-heading { margin-bottom: 24px; }
h2 { margin: 8px 0; color: #303133; font-size: 24px; }
p { color: #909399; margin: 0; }
.list-panel { background: white; padding: 20px; margin-top: 20px; border-radius: 6px; }
.list-heading { margin-bottom: 16px; color: #303133; }
a { color: #409eff; word-break: break-all; }
@media (max-width: 640px) { .xingxiang-actions { padding: 12px; } .page-heading { align-items: flex-start; } .list-panel { padding: 12px; } }
</style>



// WEBPACK FOOTER //
// src/components/main/XingxiangActionList.vue